import { supabase } from "@/services/supabase/createClient";

export const contactSales = async () => {
  await supabase.functions.invoke("bff/api/contact_sales", {});
};
